import { render, staticRenderFns } from "./work_edit_priority.vue?vue&type=template&id=59f25f88&scoped=true"
import script from "./work_edit_priority.vue?vue&type=script&lang=js"
export * from "./work_edit_priority.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f25f88",
  null
  
)

export default component.exports